import React from 'react';
export function Logo() {
  return <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rkjmM9B9uiCFKAdP2TDwya/image.png" alt="Brighthands Appliance Repair logo" className="h-12 w-auto" data-id="element-126" />;
}